<div
    class="provider-card"
    (click)="onProviderClicked()"
    style="cursor: pointer"
>
    <div class="card-inner flex gap-4">
        
        @if(blobUrl()===''){
        <div class="position-relative pr-4">
            <p-skeleton class="avatar-skeleton" shape="circle" size="4rem" />
        </div>
        }@else{
        <img [src]="blobUrl()" width="55" height="50"/>
        }
        <div class="card-content">
            <h6 class="my-2">{{ provider.name }}</h6>
            <div class="status-container">
                <p-tag
                    class="status-tag"
                    icon="pi pi-shield"
                    severity="success"
                    *ngIf="provider.status.toString() === 'ACTIVE'"
                    [value]="provider.status | translate"
                ></p-tag>
                <p-tag
                    class="status-tag"
                    icon="pi pi-shield"
                    severity="warning"
                    *ngIf="provider.status.toString() === 'INACTIVE'"
                    [value]="provider.status | translate"
                ></p-tag>
            </div>
        </div>
    </div>
</div>
